<template>
  <div>
    <b-card>
      <template #header>
        <b-row>
          <b-col cols="auto" class="d-flex align-self-center mb-0">
            <b-link :to="{name: 'Appearance'}">
              <h4 class="ms-2 mb-0">
                {{label.sidebar.Appearance}}
              </h4>
            </b-link>
            <h4 class="mb-0">
              /
            </h4>
            <h4 class="me-2 mb-0">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col>
            <b-col lg="2" class="p-0 align-self-center">
              <b-dropdown variant="ps-base" size="sm" class="me-3 text-center">
                <template #button-content>
                  <b-icon icon="diagram3" class="me-1"></b-icon>
                  {{label.pages.fileCategory}}
                </template>
                <b-dropdown-item
                    class="sub-header-dd-item border-bottom"
                    v-for="type in fileType"
                    :key="type.id"
                    @click="edit(type)"
                >
                  <b-icon icon="pencil-square" scale="0.7" class="ms-1" />
                  {{ type.label }}
                </b-dropdown-item>
                <b-dropdown-item
                    class="sub-header-dd-item pt-2 p-fs-n text-success"
                    @click="addTypeModal=true"
                >
                  <b-icon
                      icon="plus"
                      scale="1.4"
                      variant="success"
                      class="align-middle"
                  />
                  {{ label.buttons.newCategory }}
                </b-dropdown-item>
              </b-dropdown>
            </b-col>
          </b-col>
          <b-col cols="2" class="dir-text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-row>
            <b-col class="mb-3 mt-2" cols="12">
              <b-row class="px-1">
                <b-col lg="auto">
                  <small class="fs9">
                    {{label.pages.dateOfShow}}
                  </small>
                </b-col>
                <b-col lg="2">
                  <v-select
                      id="fileType"
                      :options="times"
                      v-model="selectedTime"
                      @input="action"
                      size="sm"
                      class="ps_select"
                      :placeholder="label.form.showAll"
                  >
                    <template #no-options>
                      {{label.pages.notFoundCase}}
                    </template>
                  </v-select>
                </b-col>
                <b-col lg="auto">
                  <small class="fs9">
                    {{label.pages.fileTypeFilter}}
                  </small>
                </b-col>
                <b-col lg="2">
                  <v-select
                      id="type"
                      :options="typesOption"
                      v-model="selectedType"
                      :reduce="group => group.value"
                      @input="action"
                      size="sm"
                      class="ps_select"
                      :placeholder="label.form.showAll"
                  >
                    <template #no-options>
                      {{label.pages.notFoundCase}}
                    </template>
                  </v-select>
                </b-col>
                <b-col lg="auto" v-if="fileType && fileType.length > 0">
                  <small class="fs9">
                    {{label.pages.categoryFilter}}
                  </small>
                </b-col>
                <b-col lg="2" v-if="fileType && fileType.length > 0">
                  <v-select
                      id="type"
                      :options="fileType"
                      v-model="selectedFileType"
                      :reduce="group => group.id"
                      @input="action"
                      size="sm"
                      class="ps_select"
                      :placeholder="label.form.showAll"
                  >
                    <template #no-options>
                      {{label.pages.notFoundCase}}
                    </template>
                  </v-select>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="2" md="4" sm="6" class="px-3 py-2" @click="add">
              <div class="files-box-new">
                <b-icon
                    scale="3.7"
                    icon="plus"
                    variant="success"
                    class="mt-5"
                ></b-icon>
                <h2> {{label.pages.uploadNewFile}}</h2>
              </div>
            </b-col>
            <b-col v-show="files && files.length > 0" v-for="file in files" :key="file.id" lg="2" md="4" sm="6" class="px-3 py-2" @click="select(file.id)">
              <div class="files-box">
                <img
                    class="image-contain"
                    :src="file.fileAddress"
                    :alt="file.title"
                    v-if="
                      file.extension === '.jpg' ||
                      file.extension === '.JPG' ||
                      file.extension === '.png' ||
                      file.extension === '.PNG' ||
                      file.extension === '.jpeg' ||
                      file.extension === '.webp'||
                      file.extension === '.gif'
                    "
                />
                <div class="file-box-icon" v-else>
                  <b-icon
                      icon="file-earmark-excel"
                      v-if="file.extension === '.xlsx'"
                  />
                  <b-icon icon="file-earmark-text" v-if="file.extension === '.pdf'" />
                  <b-icon
                      icon="file-earmark-word"
                      v-if="file.extension === '.docx'"
                  />
                  <b-icon icon="file-earmark-word" v-if="file.extension === '.doc'" />
                  <b-icon icon="file-earmark-text" v-if="file.extension === '.txt'" />
                  <b-icon icon="file-earmark-zip" v-if="file.extension === '.zip'" />
                  <b-icon icon="file-earmark-play" v-if="file.extension === '.mp4' || file.extension === '.mkv'" />
                  <b-icon icon="file-earmark-music" v-if="file.extension === '.mp3' || file.extension === '.wav'" />
                </div>
                <h5 dir="ltr" v-if="file.title" class="mt-2 mb-0">{{ file.title | charactersLimit(21) }}</h5>
                <h5 dir="ltr" v-else class="mt-2 mb-0">{{ file.fileName | charactersLimit(21) }}</h5>
                <span
                    class="box-label-date"
                    v-b-tooltip.noninteractive.hover.left
                    :title="label.pages.timeToUpload"
                >
                {{ file.createdLocal }}
                </span>
                <span
                    class="box-label-extention"
                    v-b-tooltip.noninteractive.hover.left
                    :title="label.pages.suffixFile"
                >
               {{ file.extension }}
                </span>
                <span class="box-label-size" v-b-tooltip.noninteractive.hover.left title="حجم فایل">
                  {{ formatBytes(file.size) }}
                </span>
                <span v-if="file.fileTypeTitle" class="box-label-type" v-b-tooltip.noninteractive.hover.right title="نوع فایل">
                  {{ file.fileTypeTitle }}
                </span>
              </div>
            </b-col>
            <b-col v-if="files.length <= 0" cols="8" class="align-self-center text-center">
              <p class="m-0 text-ps-secondary">
                {{ label.errors.emptyList }}
              </p>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!--  Add Modal -->
    <b-modal
        :dir="label.direction"
        v-model="addModal"
        header-bg-variant="ps-success"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col sm="3">
            <label for="Title" class="ps_label">{{label.pages.title}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="Title" v-model="form.title" size="sm"/>
          </b-col>
        </b-row>
        <b-row class="mb-3 mt-1">
          <b-col sm="3">
            <label for="fileType" class="ps_label">{{label.pages.categoryFile}}</label>
          </b-col>
          <b-col sm="7">
            <v-select
                id="fileType"
                :options="fileType"
                v-model="form.fileType"
                :reduce="group => group.id"
                size="sm"
                class="ps_select">
              <template #no-options>
                {{label.pages.notFoundCase}}
              </template>
            </v-select>
          </b-col>
          <b-col class="ps-0" sm="2">
            <b-button
                variant="ps-success"
                size="md"
                class="mx-1"
                v-b-tooltip.noninteractive.hover
                :title="label.pages.categoryFile"
                @click="addTypeModal=true"
            >
              <b-icon icon="plus" scale="1.7"></b-icon>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="12">
            <drop-zone-custom
                mode="all"
                :isRequired="true"
                :add="false"
                :edit="false"
                :editText="label.pages.file"
            />
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="addModal=false"
            >
            {{label.pages.cansel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                size="sm"
                class="mx-1"
                @click="addFile"
            >
            {{label.pages.save}}
            </b-button>
            <b-button
                v-else
                variant="ps-success"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Confirm Modal -->
    <b-modal
        :dir="label.direction"
        v-model="delModal"
        hide-header
        centered
        size="sm"
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 fw-bold text-center m-0">
            {{label.pages.deleteFile}}
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1 fs8"
                @click="delModal=false"
            >
            {{label.pages.cansel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1 fs8"
                @click="deleteFile"
            >
            {{label.pages.delete2}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Detail Modal -->
    <b-modal
        :dir="label.direction"
        v-model="detModal"
        hide-header
        centered
        size="lg"
    >
      <template #modal-header>
        <h4 class="text-dark fw1 fs-large pt-2">
          <strong>
            {{label.pages.showFile}}
          </strong>
        </h4>
        <button
            class="ps-closeModalBtn text-black"
            @click="detModal=false"
            v-b-tooltip.hover
            :title="label.pages.closeTab"
        >
          <b-icon icon="x-lg"></b-icon>
        </button>
      </template>
      <b-container fluid>
        <b-row class="mt-2">
          <b-col>
            <img
                class="file-detail-box-image"
                width="100%"
                height="auto"
                :src="fileById.fileAddress"
                :alt="fileById.title"
                v-if="
                fileById.extension === '.jpg' ||
                fileById.extension === '.JPG' ||
                fileById.extension === '.png' ||
                fileById.extension === '.PNG' ||
                fileById.extension === '.jpeg' ||
                fileById.extension === '.webp'||
                fileById.extension === '.gif'
              "
                v-b-tooltip.hover
                :title="label.pages.photoDownload"
                @click="downloadFile(fileById.fileAddress)"
            />
            <div
                class="file-detail-box-icon"
                v-b-tooltip.hover
                :title="label.pages.fileDownload"
                @click="downloadFile(fileById.fileAddress)"
                v-else
            >
              <b-icon
                  icon="file-earmark-excel"
                  v-if="fileById.extension === '.xlsx'"
              />
              <b-icon
                  icon="file-earmark-pdf"
                  v-if="fileById.extension === '.pdf'"
              />
              <b-icon
                  icon="file-earmark-word"
                  v-if="fileById.extension === '.docx'"
              />
              <b-icon
                  icon="file-earmark-word"
                  v-if="fileById.extension === '.doc'"
              />
              <b-icon
                  icon="file-earmark-text"
                  v-if="fileById.extension === '.txt'"
              />
              <b-icon
                  icon="file-earmark-zip"
                  v-if="fileById.extension === '.zip'"
              />
            </div>
          </b-col>
          <b-col class="align-self-center">
            <h2 v-if="fileById.title" class="text-center mb-4">{{ fileById.title }}</h2>
            <p v-if="fileById.fileType" class="fs10 text-center">
              {{label.pages.typeOfFile}}
              <strong>{{ fileById.fileType }}</strong>
            </p>
            <p v-if="fileById.size" class="fs10 text-center">
              {{label.pages.massOfFile}}
              <strong>{{ formatBytes(fileById.size) }}</strong>
            </p>
            <p v-if="fileById.extension" class="fs10 text-center">
              {{label.pages.suffixFile}}
              <strong>{{ fileById.extension }}</strong>
            </p>
            <p v-if="fileById.createdLocal" class="fs10 text-center">
              {{label.pages.timeToUpload}}
              <strong>{{ fileById.createdLocal }}</strong>
            </p>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="detModal=false"
            >
            {{label.pages.cansel}}
            </b-button>
            <b-button
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="delConfirm(fileById.id)"
            >
              <b-icon icon="trash"></b-icon>
              {{label.pages.delete}}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Add FileType Modal -->
    <b-modal
        :dir="label.direction"
        v-model="addTypeModal"
        header-bg-variant="ps-success"
        header-class="p-2"
        centered
        size="sm"
    >
      <template #modal-header>
        <h4 class="text-white fw1 p-0 m-0 py-2">
          ثبت دسته بندی فایل جدید
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="addTypeModal=false"
            v-b-tooltip.hover
            :title="label.pages.closeTab"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col class="mb-1" sm="12">
            <label for="fileType" class="ps_label">عنوان دسته‌بندی فایل</label>
            <span class="ps_label_star">*</span>
          </b-col>
          <b-col sm="12">
            <b-form-input id="fileType" v-model="newFileType" size="sm"/>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1 fs8"
                @click="addTypeModal=false"
            >
            {{label.pages.cansel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                size="sm"
                class="mx-1 fs8"
                @click="addNewFileType"
            >
            {{label.pages.save}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-success"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Edit FileType Modal -->
    <b-modal
        :dir="label.direction"
        v-model="editTypeModal"
        header-bg-variant="ps-warning"
        header-class="p-2"
        centered
        size="sm"
    >
      <template #modal-header>
        <h4 class="text-white fw1 p-0 m-0 py-2">
          ویرایش دسته بندی
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="editTypeModal=false"
            v-b-tooltip.hover
            :title="label.pages.closeTab"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col class="mb-1" sm="12">
            <label for="fileType" class="ps_label">عنوان دسته‌بندی فایل</label>
            <span class="ps_label_star">*</span>
          </b-col>
          <b-col sm="12">
            <b-form-input id="fileType" v-model="editText" size="sm"/>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1 fs8"
                @click="editTypeModal=false"
            >
            {{label.pages.cansel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-danger"
                size="sm"
                class="mx-1 fs8"
                @click="delFileTypeConfirm"
            >
            {{label.pages.delete}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-warning"
                size="sm"
                class="mx-1 fs8"
                @click="editFileType"
            >
            {{label.pages.saveChanges}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-warning"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete FileType Modal -->
    <b-modal
        :dir="label.direction"
        v-model="delFileTypeModal"
        hide-header
        centered
        size="sm"
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 fw-bold text-center m-0">
            آیا از حذف این دسته بندی مطمئن هستید ؟
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1 fs8"
                @click="delFileTypeModal=false"
            >
            {{label.pages.cansel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1 fs8"
                @click="deleteFileType"
            >
            {{label.pages.delete2}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { dropZone } from "@/components/dropZone";
import {mapGetters} from "vuex";
import dropZoneCustom from '@/components/DropZoneCustom'
import label from "@/plugins/StaticLabels.js";

export default {
  name: 'FileManagement',
  mixins: [dropZone],
  components: {
    dropZoneCustom
  },
  data() {
    return {
      label,
      addModal: false,
      delModal: false,
      detModal: false,
      addTypeModal: false,
      editTypeModal: false,
      delFileTypeModal: false,
      editText: null,
      editId: null,
      delFTId: null,
      file: null,
      delId: null,
      newFileType: null,
      form: {
        title: null,
        fileType: null,
      },
      selectedTime: null,
      selectedType: null,
      selectedFileType: null,
      typesOption: [
        {
          id: 1,
          label: label.captions.image,
          value: 'image',
        },
        {
          id: 2,
          label: label.captions.audio,
          value: 'audio',
        },
        {
          id: 3,
          label: label.captions.video,
          value: 'video',
        },
        {
          id: 4,
          label: label.captions.file,
          value: 'file',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      files: 'baseX/files',
      fileById: 'baseX/file',
      fileType: 'baseX/fileType',
      url: 'url',
      times: 'baseX/filesTime',
      loadingBtn: 'loadingBtn',
    }),
  },
  watch: {
    postCheck() {
      this.delModal = false;
      this.delFileTypeModal = false;
      this.editTypeModal = false;
      this.detModal = false;
      this.reloadForm();
      this.reloadData();
      this.action();
    },
    times() {
      if (this.times[0]) {
        this.selectedTime = this.times[0];
      }
      setTimeout(() => {
        this.action();
      }, 800);
    },
    url() {
      if (this.url && this.url.length > 0) {
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
  },
  methods: {
    handleImageUpload(file) {
      this.file = file;
    },
    action() {
      const payload = {
        pageSize: 1000000,
        pageNumber: 1,
        time: this.selectedTime,
        type: this.selectedType,
        fileTypeId: this.selectedFileType,
      }
      this.$store.dispatch('baseX/getFiles', payload);
    },
    add() {
      this.addModal = true;
    },
    addFile() {
      this.$store.commit("setLoadingBtn", true);
      const payload = {
        data: {
          FileTypeId: this.form.fileType,
          Title: this.form.title,
        },
        id: this.url[0].id
      }
      this.$store.dispatch('baseX/addFile', payload);
      this.addModal = false;
    },
    addNewFileType() {
      this.$store.commit("setLoadingBtn", true);
      const payload = {
        Title: this.newFileType
      }
      this.$store.dispatch('baseX/addFileType', payload);
      this.addTypeModal = false;
    },
    edit(item) {
      this.editText = item.label;
      this.editId = item.id;
      this.editTypeModal = true;
    },
    editFileType() {
      this.$store.commit("setLoadingBtn", true);
      const payload = {
        value: {
          Title: this.editText,
        },
        id: this.editId
      }
      this.$store.dispatch('baseX/editFileType', payload);
      this.editTypeModal = false;
    },
    delFileTypeConfirm() {
      this.delFTId = this.editId;
      this.delFileTypeModal = true;
    },
    deleteFileType() {
      this.$store.commit("setLoadingBtn", true);
      this.$store.dispatch('baseX/deleteFileType', this.delFTId);
    },
    delConfirm(id) {
      this.delId = id;
      this.delModal = true;
    },
    deleteFile() {
      this.$store.commit("setLoadingBtn", true);
      this.$store.dispatch('baseX/deleteFile', this.delId);
    },
    select(id) {
      this.$store.dispatch('baseX/getFile', id);
      this.detModal = true;
    },
    downloadFile(address) {
      window.open(address, "_blank");
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    reloadForm() {
      this.file = null;
      this.delId = null;
      this.newFileType = null;
      this.editText = null;
      this.editId = null;
      this.form = {
        title: null,
        fileType: null,
      };
    },
    reloadData() {
      const payload = {
        pageSize: 1000000,
        time: this.selectedTime,
        type: null,
        fileTypeId: null,
      }
      this.$store.dispatch('baseX/getFiles', payload);
      this.$store.dispatch('baseX/getFileType');
    }
  },
  beforeCreate() {
    const payload = {
      pageSize: 1000000,
      time: this.selectedTime,
      type: null,
      fileTypeId: null,
    }
    this.$store.dispatch('baseX/getFiles', payload);
    this.$store.dispatch('baseX/getFilesTime');
    this.$store.dispatch('baseX/getFileType');
  }
}
</script>
